var _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _path7, _circle3, _path8, _circle4, _path9, _circle5, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFxTransactionsEmptyHhmtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h200v200H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.568 36.878A4.878 4.878 0 0 1 56.446 32h72.474a4.878 4.878 0 1 1 0 9.756h-15.331a4.878 4.878 0 1 0 0 9.756h35.54a6.272 6.272 0 1 1 0 12.544H39.721a6.272 6.272 0 1 1 0-12.544h29.965a4.867 4.867 0 0 1-1.742-.32 4.88 4.88 0 0 0 0-9.116 4.867 4.867 0 0 1 1.742-.32h-13.24a4.878 4.878 0 0 1-4.878-4.878Zm106.62 20.906a6.272 6.272 0 0 1 6.272-6.272h12.543a6.272 6.272 0 1 1 0 12.544H164.46a6.272 6.272 0 0 1-6.272-6.272ZM39.721 73.812a6.272 6.272 0 1 0 0 12.543h85.715a6.272 6.272 0 0 0 0-12.543H39.721ZM6.969 101.338a5.226 5.226 0 0 1 5.226-5.226h42.509a5.226 5.226 0 1 1 0 10.452h-2.09a5.227 5.227 0 0 0 0 10.453h33.449a5.226 5.226 0 1 1 0-10.453h78.745a5.227 5.227 0 1 1 0 10.453h-14.285a5.227 5.227 0 1 0 0 10.453h8.014a5.227 5.227 0 0 1 0 10.453h-32.056a5.227 5.227 0 0 1 0 10.453H85.366a5.227 5.227 0 0 0 0 10.453h6.272a5.227 5.227 0 0 1 0 10.453H48.432a5.226 5.226 0 1 1 0-10.453h.697a5.226 5.226 0 1 0 0-10.453H5.226a5.226 5.226 0 1 1 0-10.453h20.906a5.226 5.226 0 1 1 0-10.453h1.046a5.226 5.226 0 1 0 0-10.453h-2.44a5.226 5.226 0 1 1 0-10.453H12.196a5.226 5.226 0 0 1-5.226-5.226Zm174.564 5.226a5.227 5.227 0 0 0 0 10.453h13.241a5.226 5.226 0 0 0 0-10.453h-13.241Z",
    fill: "#F6F8FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.345 150.467a4.181 4.181 0 0 0 0 8.362h9.059a4.181 4.181 0 0 0 0-8.362h-9.059Z",
    fill: "#F6F8FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.121 29.53a2.062 2.062 0 1 1 0 4.124H46.748a2.062 2.062 0 0 1 0-4.124H59.12Zm-22.685 0a2.062 2.062 0 1 1 0 4.124H24.062a2.062 2.062 0 0 1 0-4.124h12.374Zm7.218 19.591a2.062 2.062 0 1 1-4.125 0V36.748a2.062 2.062 0 0 1 4.125 0V49.12Zm0-22.685a2.062 2.062 0 0 1-4.125 0V14.062a2.062 2.062 0 0 1 4.125 0v12.374Zm130.741 110.876a1.09 1.09 0 0 1 1.54 1.539l-4.618 4.618a1.088 1.088 0 1 1-1.539-1.54l4.617-4.617Zm-8.466 8.466a1.09 1.09 0 0 1 1.54 1.539l-4.618 4.618a1.09 1.09 0 0 1-1.54-1.54l4.618-4.617Zm10.006 4.617a1.09 1.09 0 0 1-1.54 1.54l-4.617-4.618a1.088 1.088 0 1 1 1.539-1.539l4.618 4.617Zm-8.466-8.466a1.09 1.09 0 0 1-1.54 1.54l-4.618-4.618a1.088 1.088 0 1 1 1.54-1.539l4.618 4.617ZM21.252 106.088a1.088 1.088 0 0 1 2.177 0v6.531a1.088 1.088 0 0 1-2.177 0v-6.531Zm0 11.973a1.088 1.088 0 0 1 2.177 0v6.531a1.088 1.088 0 0 1-2.177 0v-6.531Zm10.34-3.809a1.088 1.088 0 1 1 0 2.177h-6.53a1.089 1.089 0 0 1 0-2.177h6.53Zm-11.972 0a1.088 1.088 0 1 1 0 2.177h-6.532a1.089 1.089 0 0 1 0-2.177h6.531Z",
    fill: "#D4DDEC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.354,
    cy: 104.354,
    fill: "#EEF2F5",
    r: 4.354
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.354,
    cy: 168.354,
    fill: "#EEF2F5",
    r: 4.354
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.884 181.048a8.164 8.164 0 1 0 0-16.328 8.164 8.164 0 0 0 0 16.328Zm0 2.721c6.012 0 10.885-4.873 10.885-10.885 0-6.011-4.873-10.884-10.885-10.884-6.011 0-10.884 4.873-10.884 10.884 0 6.012 4.873 10.885 10.884 10.885Zm54-145.721a8.164 8.164 0 1 0 .001-16.327 8.164 8.164 0 0 0-.001 16.327Zm0 2.72c6.012 0 10.885-4.872 10.885-10.884 0-6.01-4.873-10.884-10.885-10.884C158.873 19 154 23.873 154 29.884c0 6.012 4.873 10.885 10.884 10.885Z",
    fill: "#D4DDEC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m61.658 111.221-26.276 26.27 16.675 21.91 9.413-6.377 67.919 1.677a15.739 15.739 0 0 0 13.247-6.66l39.367-55.802a6.676 6.676 0 0 0-10.214-8.53l-41.42 42.103a4.197 4.197 0 0 1-3.347 1.238l-30.116-2.573a.66.66 0 1 1 .116-1.315l20.797 1.892a6.833 6.833 0 0 0 1.679-13.553l-39.592-6.22a21.164 21.164 0 0 0-18.248 5.94Z",
    fill: "url(#a)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.18 149.344a3.2 3.2 0 0 1 .45-4.502l12.693-10.383a3.199 3.199 0 0 1 4.502.45l19.65 24.019a3.2 3.2 0 0 1-.451 4.502L42.33 173.813a3.2 3.2 0 0 1-4.502-.45L18.18 149.344Z",
    fill: "url(#b)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.281,
    cy: 97.28,
    r: 14.208,
    transform: "rotate(20.476 147.281 97.28)",
    fill: "url(#c)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.89 89.61c-.094-.638.331-1.249.95-1.365.62-.116 1.198.306 1.292.943l.901 6.077 4.664-4c.489-.419 1.202-.358 1.594.135.391.494.312 1.234-.177 1.654l-4.226 3.624 1.22.455c.583.218.871.889.644 1.499-.228.61-.886.928-1.469.71l-2.113-.789-.412 1.105 2.112.788c.584.218.872.889.644 1.499-.227.61-.885.928-1.468.71l-2.113-.789-1.237 3.314c-.228.61-.886.928-1.469.71-.583-.218-.872-.889-.644-1.499l1.237-3.313-2.112-.789c-.584-.218-.872-.89-.644-1.5.228-.61.885-.927 1.469-.71l2.112.79.413-1.105-2.113-.789c-.583-.218-.872-.888-.644-1.498.228-.61.885-.928 1.469-.71l.936.35-.816-5.508Z",
    fill: "#D2D9E7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.067,
    cy: 61.066,
    r: 30.5,
    transform: "rotate(-1.075 108.067 61.066)",
    fill: "url(#d)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m106.284 81.656-.109-4.723c-2.129-.045-4.249-.405-5.984-.93a2.855 2.855 0 0 1-1.962-3.4l.04-.186c.381-1.625 2.066-2.612 3.654-2.095 1.617.528 3.462.863 5.409.818 2.825-.062 4.756-1.202 4.695-3.189-.048-1.897-1.668-3.047-5.379-4.21-5.368-1.675-9.036-4.08-9.14-8.9-.1-4.367 2.906-7.862 8.203-9.033l-.109-4.722 4.87-.101.129 4.378c1.814.037 3.3.262 4.555.562 1.528.375 2.474 1.91 2.099 3.437-.378 1.577-1.974 2.55-3.548 2.122a15.81 15.81 0 0 0-4.369-.522c-3.231.069-4.251 1.489-4.204 2.883.033 1.64 1.809 2.65 6.064 4.132 5.964 1.947 8.411 4.635 8.506 9.1.098 4.416-2.949 8.264-8.648 9.391l.118 5.078-4.89.11Z",
    fill: "#EDF0F6",
    fillOpacity: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.236,
    cy: 88.236,
    r: 19.349,
    transform: "rotate(-28.491 51.236 88.236)",
    fill: "url(#e)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M61.287 92.654a1.31 1.31 0 0 1 .005 1.643c-.74.917-1.974 2.018-3.555 2.84-2.312 1.204-5.002 1.6-7.591.715-1.617-.543-3.188-1.668-4.413-3.22l-1.358.71c-.457.238-1.045.043-1.293-.435l-.02-.04c-.248-.478-.08-1.073.378-1.31l1.123-.585c-.248-.376-.408-.618-.522-.836a10.755 10.755 0 0 1-.564-1.337l-1.15.602c-.457.237-1.044.042-1.293-.435-.248-.477-.08-1.072.378-1.31l1.398-.73c-.5-1.876-.513-3.777-.04-5.415.801-2.797 2.76-4.928 5.162-6.186 1.411-.731 2.602-1.034 3.593-1.157.688-.09 1.331.402 1.458 1.109l.004.028c.13.735-.337 1.406-1.037 1.511-.81.118-1.738.393-2.783.94-1.541.802-2.8 2.122-3.379 4.002-.309 1.1-.356 2.374.067 3.596l7.86-4.118c.456-.238 1.044-.043 1.292.435.25.477.08 1.072-.377 1.31l-8.213 4.3c.17.414.355.84.49 1.1.17.327.343.654.61 1.071l8.225-4.316c.47-.253 1.073-.045 1.323.446.264.49.083 1.1-.388 1.34l-7.873 4.12c.802.935 1.76 1.58 2.744 1.904 1.92.611 3.6.399 5.336-.512a10.426 10.426 0 0 0 2.55-1.908c.499-.545 1.376-.482 1.853.129Z",
    fill: "#EEF2F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 92,
    y1: 91.5,
    x2: 98,
    y2: 178.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 38.523,
    y1: 132.812,
    x2: 37.773,
    y2: 193.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACB1C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 147.281,
    y1: 83.072,
    x2: 147.281,
    y2: 111.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AA7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 108.067,
    y1: 30.566,
    x2: 108.067,
    y2: 91.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0ADC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 51.236,
    y1: 68.886,
    x2: 51.236,
    y2: 107.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EABC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFxTransactionsEmptyHhmtIcon);
export default __webpack_public_path__ + "static/media/fx-transactions-empty-hhmt-icon.d495add60580584a7fd34afd8681f306.svg";
export { ForwardRef as ReactComponent };